/* tslint:disable:typedef-whitespace align no-trailing-whitespace */

import { Action, ActionType    } from '@/models/action';
import { Logger                } from '@/util/logger';

/**
 *
 * @class WindowSaveLayoutAction
 *
 * @brief save the current workspace layout as the default
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2020
 *
 */
export class WindowSaveLayoutAction extends Action {

  constructor(options: any = null) {

    super({
      key:   'window.layout.save',
      type:  ActionType.Window_Save_Layout,
      label: 'Save Layout',
      icon:  '<i class="far fa-save"></i>',
      tip:   'Save the current workspace layout as the default.'
    });


  }

  /* is this action enabled? */
  public enabled(): boolean {

    return true;
  }

  /** implement the action */
  public execute(): boolean {

    if (!this.enabled()) {
      return false;
    }

    Logger.debug('[WindowSaveLayoutAction] executing...');



    return true;
  }
}
